import {
  formatDate,
  formatEventSeverity,
  formatSource,
} from "fleet/view/incidents/table-format";
import PropTypes from "prop-types";
import React from "react";
import { Table, Column } from "ui/table";
import { sortByProp } from "util/sort-by-prop";

class EventsTable extends React.PureComponent {
  static get propTypes() {
    return {
      events: PropTypes.array.isRequired,
    };
  }

  static _sortSource(a, b, order) {
    return sortByProp("id", order, a.source, b.source);
  }

  constructor(props) {
    super(props);

    this.options = {
      defaultSortName: "event_date",
      defaultSortOrder: "asc",
    };
  }

  _getEventData() {
    const { events } = this.props;

    return events.map((event, id) => {
      return {
        ...event,
        id: id,
      };
    });
  }

  render() {
    const tableData = this._getEventData();

    return (
      <Table
        data={tableData}
        options={this.options}
        hover={true}
        pagination={false}
      >
        <Column key="id" dataField="id" isKey={true} hidden>
          ID
        </Column>
        <Column dataField="event_date" dataFormat={formatDate} dataSort={true}>
          Date
        </Column>
        <Column dataField="name" dataSort={true}>
          Name
        </Column>
        <Column
          dataField="severity"
          dataSort={true}
          dataFormat={formatEventSeverity}
        >
          Severity
        </Column>
        <Column
          dataField="source"
          sortFunc={this.constructor._sortSource}
          dataSort={true}
          dataFormat={formatSource}
        >
          Source
        </Column>
      </Table>
    );
  }
}

export { EventsTable };
